import { useEditorialAccess } from 'app/context/editorialAccess.context';
import { useAuthUser } from 'app/hooks/useAuthUser';
import { hasRestrictedProgramAccess } from 'app/models/editorialAccess';

export default function useRestrictedPrograms() {
  const access = useEditorialAccess();
  const { authUser } = useAuthUser();

  return hasRestrictedProgramAccess(access, authUser);
}
